import { createContext } from 'react';

import { PageTemplateMenuStore } from './PageTemplateMenuStore';

const PageTemplateMenuStoreContext = createContext<{
  store: PageTemplateMenuStore | null;
}>({
  store: null
});

const PageTemplateMenuStoreProvider = PageTemplateMenuStoreContext.Provider;

export { PageTemplateMenuStoreContext, PageTemplateMenuStoreProvider };
